import {gsap} from 'gsap';

// ─────────────────────────────────────────────────────────────────────────────
// GEO COSTELLAZIONI  →  pagina /geo, sezione "geo-spiegazioni"
// ─────────────────────────────────────────────────────────────────────────────
// Crea due mini-costellazioni animate su canvas (una grande a sinistra,
// una più piccola a destra). Ogni costellazione ha:
//   - NODE_COUNT nodi (quadratini bianchi) che si muovono lentamente
//   - Linee bianche che collegano i nodi entro una certa distanza (maxDist)
//   - Opacità delle linee proporzionale alla vicinanza dei nodi
//
// Valori modificabili:
//   NODE_COUNT  → numero di nodi per costellazione (default: 9)
//   * 0.65      → distanza massima entro cui si disegnano le linee (% del canvas)
//   * 0.18      → velocità di movimento dei nodi (più alto = più veloce)
//   * 0.6       → opacità massima delle linee (0–1)
//   lineWidth   → spessore delle linee
//   sq          → dimensione in px dei quadratini
//   strokeStyle → colore delle linee        ← modifica qui
//   fillStyle   → colore dei quadratini     ← modifica qui
// ─────────────────────────────────────────────────────────────────────────────
function initGeoCostellazione() {
    const canvases = document.querySelectorAll('.geo-costellazione__canvas');
    if (!canvases.length) {
        return null;
    }

    canvases.forEach(function (canvas) {
        const ctx = canvas.getContext('2d');
        const NODE_COUNT = 9;
        let nodes = [];
        let maxDist = 0;

        // Colore: dark se data-color="dark", altrimenti white (default)
        const isDark = canvas.dataset.color === 'dark';
        const rgb = isDark ? '30,30,30' : '255,255,255';

        // Ridimensiona il canvas e reinizializza i nodi
        function resize() {
            const parent = canvas.parentElement;
            canvas.width = canvas.offsetWidth || (parent && parent.clientWidth) || 400;
            canvas.height = canvas.offsetHeight || (parent && parent.clientHeight) || 400;
            maxDist = Math.min(canvas.width, canvas.height) * 0.65;
            nodes = [];
            for (let i = 0; i < NODE_COUNT; i++) {
                nodes.push({
                    x: Math.random() * canvas.width,
                    y: Math.random() * canvas.height,
                    vx: (Math.random() - 0.5) * 0.18,
                    vy: (Math.random() - 0.5) * 0.18
                });
            }
        }

        function draw() {
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            // Aggiorna posizione di ogni nodo (rimbalza sui bordi)
            nodes.forEach(function (n) {
                n.x += n.vx;
                n.y += n.vy;
                if (n.x < 0 || n.x > canvas.width) {
                    n.vx *= -1;
                }
                if (n.y < 0 || n.y > canvas.height) {
                    n.vy *= -1;
                }
            });

            // Disegna le linee tra nodi entro maxDist
            for (let i = 0; i < nodes.length; i++) {
                for (let j = i + 1; j < nodes.length; j++) {
                    const dx = nodes[i].x - nodes[j].x;
                    const dy = nodes[i].y - nodes[j].y;
                    const dist = Math.sqrt(dx * dx + dy * dy);
                    if (dist < maxDist) {
                        const alpha = (1 - dist / maxDist) * 0.6;
                        ctx.beginPath();
                        ctx.moveTo(nodes[i].x, nodes[i].y);
                        ctx.lineTo(nodes[j].x, nodes[j].y);
                        ctx.strokeStyle = 'rgba(' + rgb + ',' + alpha + ')';
                        ctx.lineWidth = 1.2;
                        ctx.stroke();
                    }
                }
            }

            // Disegna i quadratini sui nodi
            const sq = 7;
            nodes.forEach(function (n) {
                ctx.fillStyle = 'rgba(' + rgb + ',1)';
                ctx.fillRect(n.x - sq / 2, n.y - sq / 2, sq, sq);
            });

            requestAnimationFrame(draw);
        }

        // Aspetta un frame per assicurarsi che il CSS sia applicato
        requestAnimationFrame(function () {
            resize();
            $(window).on('resize', resize);
            draw();
        });
    });
}


// ─────────────────────────────────────────────────────────────────────────────
// GEO UNIVERSO  →  pagina /geo, sezione "geo-universo" (canvas a tutta viewport)
// ─────────────────────────────────────────────────────────────────────────────
// Crea l'animazione dell'universo/costellazione su canvas fullscreen.
// È composta da tre layer sovrapposti:
//   1. STELLE  — cerchi piccoli che pulsano (opacity sinusoidale)
//   2. LINEE   — collegano i nodi entro maxDist con opacità proporzionale alla distanza
//   3. NODI    — cerchi che si muovono lentamente e rimbalzano sui bordi
// Inoltre anima con GSAP le label testuali (AEO, GEO, SEO, AIO) in fade-in.
//
// Valori modificabili:
//   STAR_COUNT  → numero di stelle di sfondo (default: 420)
//   NODE_COUNT  → numero di nodi della costellazione (default: 55)
//   * 0.15      → distanza massima linee (% della larghezza canvas)
//   * 0.25      → velocità nodi
//   * 0.005     → velocità pulsazione stelle
//   strokeStyle → colore linee nodi    ← modifica qui
//   fillStyle   → colore nodi          ← modifica qui
// ─────────────────────────────────────────────────────────────────────────────
function initGeoUniverso() {
    const $canvas = $('#universoCanvas');
    if (!$canvas.length) {
        return null;
    }

    const canvas = $canvas[0];
    const ctx = canvas.getContext('2d');

    const STAR_COUNT = 420;
    const NODE_COUNT = 55;
    const stars = [];
    const nodes = [];
    let maxDist = 0;
    let frame = 0;

    // Ridimensiona canvas e reinizializza stelle e nodi
    function resize() {
        const parent = canvas.parentElement;
        canvas.width = canvas.offsetWidth || (parent && parent.clientWidth) || window.innerWidth;
        canvas.height = canvas.offsetHeight || (parent && parent.clientHeight) || window.innerHeight;
        maxDist = Math.min(canvas.width, 1920) * 0.15;
        initStars();
        initNodes();
    }

    // Layer 1 — stelle di sfondo (cerchi piccoli che pulsano)
    function initStars() {
        stars.length = 0;
        for (let i = 0; i < STAR_COUNT; i++) {
            stars.push({
                x: Math.random() * canvas.width,
                y: Math.random() * canvas.height,
                r: Math.random() * 1.2 + 0.2,   // raggio 0.2–1.4px
                baseOpacity: Math.random() * 0.6 + 0.2,   // opacità base 0.2–0.8
                opacity: 0,
                speed: Math.random() * 0.005 + 0.002, // velocità pulsazione
                phase: Math.random() * Math.PI * 2    // fase iniziale casuale
            });
        }
    }

    // Layer 2+3 — nodi della costellazione (si muovono e generano linee)
    function initNodes() {
        nodes.length = 0;
        for (let i = 0; i < NODE_COUNT; i++) {
            nodes.push({
                x: Math.random() * canvas.width,
                y: Math.random() * canvas.height,
                vx: (Math.random() - 0.5) * 0.25, // velocità orizzontale
                vy: (Math.random() - 0.5) * 0.25, // velocità verticale
                r: Math.random() * 2.5 + 1.5     // raggio nodo 1.5–4px
            });
        }
    }

    function draw() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        frame++;

        // Disegna le stelle con pulsazione sinusoidale (quadratini)
        $.each(stars, function (i, s) {
            s.opacity = s.baseOpacity + Math.sin(frame * s.speed + s.phase) * 0.2;
            ctx.fillStyle = 'rgba(255,255,255,' + Math.max(0, s.opacity) + ')';
            ctx.fillRect(s.x - s.r, s.y - s.r, s.r * 2, s.r * 2);
        });

        // Aggiorna posizione nodi (rimbalzano sui bordi)
        $.each(nodes, function (i, n) {
            n.x += n.vx;
            n.y += n.vy;
            if (n.x < 0 || n.x > canvas.width) {
                n.vx *= -1;
            }
            if (n.y < 0 || n.y > canvas.height) {
                n.vy *= -1;
            }
        });

        // Disegna le linee tra nodi entro maxDist
        for (let i = 0; i < nodes.length; i++) {
            for (let j = i + 1; j < nodes.length; j++) {
                const dx = nodes[i].x - nodes[j].x;
                const dy = nodes[i].y - nodes[j].y;
                const dist = Math.sqrt(dx * dx + dy * dy);
                if (dist < maxDist) {
                    const alpha = (1 - dist / maxDist) * 0.55;
                    ctx.beginPath();
                    ctx.moveTo(nodes[i].x, nodes[i].y);
                    ctx.lineTo(nodes[j].x, nodes[j].y);
                    ctx.strokeStyle = 'rgba(90,170,255,' + alpha + ')'; // ← colore linee nodi
                    ctx.lineWidth = 0.6;
                    ctx.stroke();
                }
            }
        }

        // Disegna i nodi (quadratini)
        $.each(nodes, function (i, n) {
            ctx.fillStyle = 'rgba(220,235,255,1)'; // ← colore nodi
            ctx.fillRect(n.x - n.r, n.y - n.r, n.r * 2, n.r * 2);
        });

        // Cursore rosa con lerp
        cursorLX += (cursorX - cursorLX) * 0.14;
        cursorLY += (cursorY - cursorLY) * 0.14;
        cursorAlpha += (cursorTargetAlpha - cursorAlpha) * 0.1;
        if (cursorAlpha > 0.01) {
            ctx.save();
            ctx.globalAlpha = cursorAlpha;
            ctx.fillStyle = '#FF2699';
            ctx.fillRect(cursorLX - CURSOR_SIZE / 2, cursorLY - CURSOR_SIZE / 2, CURSOR_SIZE, CURSOR_SIZE);
            ctx.restore();
        }

        requestAnimationFrame(draw);
    }

    // ── Cursore rosa sul canvas ───────────────────────────────────────────────
    let cursorX = 0, cursorY = 0;
    let cursorLX = 0, cursorLY = 0;
    let cursorAlpha = 0, cursorTargetAlpha = 0;
    const CURSOR_SIZE = 24;

    canvas.addEventListener('mouseenter', function () {
        cursorTargetAlpha = 0.75;
    });
    canvas.addEventListener('mouseleave', function () {
        cursorTargetAlpha = 0;
    });
    canvas.addEventListener('mousemove', function (e) {
        const rect = canvas.getBoundingClientRect();
        cursorX = e.clientX - rect.left;
        cursorY = e.clientY - rect.top;
    });

    // Aspetta un frame per assicurarsi che il CSS sia applicato
    requestAnimationFrame(function () {
        resize();
        $(window).on('resize', resize);
        draw();

        // Fade-in delle label testuali (AEO, GEO, SEO, AIO) con GSAP
        gsap.from('.geo-label', {
            opacity: 0,
            duration: 3.5,
            stagger: 0.8,
            ease: 'power2.out'
        });

        // Animazione pallino random per ogni label
        document.querySelectorAll('.geo-label__dot').forEach(function (dot) {
            const duration = (Math.random() * 2 + 1.5).toFixed(2) + 's'; // 1.5s – 3.5s
            const delay = (Math.random() * 2).toFixed(2) + 's';        // 0s – 2s
            dot.style.animationDuration = duration;
            dot.style.animationDelay = delay;
        });

        // Hover popup per ogni label — expand clip-path dal centro
        // Traccia il popup mobile attualmente spostato fuori dal geo-label
        let mobileActiveCtx = null;
        document.querySelectorAll('.geo-label').forEach(function (label) {
            const popup = label.querySelector('.geo-label__popup');
            const dot = label.querySelector('.geo-label__dot');
            if (!popup) {
                return null;
            }
            gsap.set(popup, {
                autoAlpha: 0,
                clipPath: 'polygon(35% 35%, 65% 35%, 65% 65%, 35% 65%)'
            });
            const universo = label.closest('.geo-universo');
            label.addEventListener('mouseenter', function () {
                gsap.killTweensOf(popup);
                label.classList.add('popup-open');
                if (universo) {
                    universo.classList.add('popup-open');
                }
                // Reset eventuali correzioni applicate al hover precedente
                popup.style.marginLeft = '';
                popup.style.top = '';
                popup.style.bottom = '';
                // Mobile: ripristina il popup precedente nel suo geo-label PRIMA del loop
                // così l'eventuale querySelector('.geo-label__popup') lo troverà correttamente
                if (window.matchMedia('(max-width: 767.98px)').matches && mobileActiveCtx && mobileActiveCtx.popup !== popup) {
                    mobileActiveCtx.label.appendChild(mobileActiveCtx.popup);
                }
                // Da tablet in su: flip verticale se non c'è spazio + clamp orizzontale.
                // Su mobile è position:fixed centrato, skip.
                if (!window.matchMedia('(max-width: 767.98px)').matches) {
                    const safe = 8;
                    const vw = window.innerWidth;
                    const vh = window.innerHeight;
                    let rect = popup.getBoundingClientRect();
                    // Flip verticale: se sfora sotto e c'è più spazio sopra, lo metto sopra (e viceversa)
                    const labelRect = label.getBoundingClientRect();
                    const spaceBelow = vh - labelRect.bottom;
                    const spaceAbove = labelRect.top;
                    if (rect.bottom > vh - safe && spaceAbove > spaceBelow) {
                        popup.style.top = 'auto';
                        popup.style.bottom = 'calc(100% + 18px)';
                        rect = popup.getBoundingClientRect();
                    } else if (rect.top < safe && spaceBelow > spaceAbove) {
                        popup.style.top = 'calc(100% + 18px)';
                        popup.style.bottom = 'auto';
                        rect = popup.getBoundingClientRect();
                    }
                    // Clamp orizzontale
                    let shift = 0;
                    if (rect.right > vw - safe) {
                        shift = -(rect.right - (vw - safe));
                    } else if (rect.left < safe) {
                        shift = safe - rect.left;
                    }
                    if (shift !== 0) {
                        popup.style.marginLeft = shift + 'px';
                    }
                }
                // Mobile: sposta il popup come figlio diretto di .geo-universo prima di animarlo.
                // Alcuni label hanno transform:translateX(-50%) inline (center:true) oppure GSAP
                // può aggiungere un compositing layer, rendendo .geo-label un containing block
                // per i figli position:fixed — il popup non risulterebbe centrato nel viewport.
                // Spostandolo su .geo-universo (position:relative, nessun transform) il
                // position:fixed del popup torna a riferirsi correttamente al viewport.
                if (window.matchMedia('(max-width: 767.98px)').matches && universo) {
                    universo.appendChild(popup);
                    mobileActiveCtx = { popup: popup, label: label };
                }
                gsap.to(popup, {
                    autoAlpha: 1,
                    clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
                    duration: 0.45,
                    ease: 'power2.out'
                });
                if (dot) {
                    gsap.killTweensOf(dot);
                    dot.style.animation = 'none';
                    gsap.to(dot, {
                        scale: 1.6,
                        backgroundColor: '#FF2699',
                        opacity: 1,
                        duration: 0.3,
                        ease: 'power2.out'
                    });
                }
                // tutti gli altri label + dot → grigio
                document.querySelectorAll('.geo-label').forEach(function (other) {
                    if (other === label) {
                        return null;
                    }
                    other.classList.remove('popup-open');
                    const otherDot = other.querySelector('.geo-label__dot');
                    const otherPopup = other.querySelector('.geo-label__popup');
                    // chiude l'eventuale popup aperto sugli altri
                    if (otherPopup) {
                        gsap.killTweensOf(otherPopup);
                        gsap.to(otherPopup, {
                            autoAlpha: 0,
                            clipPath: 'polygon(35% 35%, 65% 35%, 65% 65%, 35% 65%)',
                            duration: 0.25,
                            ease: 'power2.in'
                        });
                    }
                    if (otherDot) {
                        gsap.killTweensOf(otherDot);
                        otherDot.style.animation = 'none';
                        gsap.set(otherDot, {backgroundColor: '#888888'});
                    }
                    gsap.killTweensOf(other);
                    gsap.to(other, {
                        color: '#888888',
                        opacity: 0.4,
                        duration: 0.3,
                        ease: 'power2.out'
                    });
                });
            });
            const closeBtn = popup.querySelector('.geo-label__popup-close');
            if (closeBtn) {
                closeBtn.addEventListener('click', function (e) {
                    e.stopPropagation();
                    label.classList.remove('popup-open');
                    if (universo) universo.classList.remove('popup-open');
                    if (window.matchMedia('(max-width: 767.98px)').matches) {
                        // Mobile: fade semplice senza clip-path — il collasso verso il centro
                        // era percepito come uno scatto indesiderato ora che il popup è centrato
                        gsap.to(popup, {
                            autoAlpha: 0,
                            duration: 0.25,
                            ease: 'power2.out',
                            onComplete: function () {
                                // Ripristina clip-path iniziale così la prossima apertura
                                // riparte correttamente dall'espansione dal centro
                                gsap.set(popup, { clipPath: 'polygon(35% 35%, 65% 35%, 65% 65%, 35% 65%)' });
                                if (mobileActiveCtx && mobileActiveCtx.popup === popup) {
                                    label.appendChild(popup);
                                    mobileActiveCtx = null;
                                }
                            }
                        });
                    } else {
                        gsap.to(popup, {
                            autoAlpha: 0,
                            clipPath: 'polygon(35% 35%, 65% 35%, 65% 65%, 35% 65%)',
                            duration: 0.5,
                            ease: 'power2.in'
                        });
                    }
                    // Su mobile mouseleave è disabilitato: ripristino colori/dot qui
                    if (window.matchMedia('(max-width: 767.98px)').matches) {
                        if (dot) {
                            gsap.killTweensOf(dot);
                            gsap.to(dot, {
                                scale: 1,
                                backgroundColor: '#ffffff',
                                opacity: 0.5,
                                duration: 0.3,
                                ease: 'power2.in',
                                onComplete: function () { dot.style.animation = ''; }
                            });
                        }
                        document.querySelectorAll('.geo-label').forEach(function (other) {
                            const otherDot = other.querySelector('.geo-label__dot');
                            gsap.killTweensOf(other);
                            gsap.to(other, {
                                color: '#ffffff',
                                opacity: 1,
                                duration: 0.3,
                                ease: 'power2.out',
                                onComplete: function () {
                                    if (otherDot) {
                                        gsap.set(otherDot, {backgroundColor: '#ffffff'});
                                        otherDot.style.animation = '';
                                    }
                                }
                            });
                        });
                    }
                });
            }

            label.addEventListener('mouseleave', function () {
                // Su mobile il popup resta aperto fino al tap su ×
                // (il touch scatena mouseenter + mouseleave in sequenza rapida)
                if (window.matchMedia('(max-width: 767.98px)').matches) { return; }
                gsap.killTweensOf(popup);
                label.classList.remove('popup-open');
                if (universo) {
                    universo.classList.remove('popup-open');
                }
                gsap.to(popup, {
                    autoAlpha: 0,
                    clipPath: 'polygon(35% 35%, 65% 35%, 65% 65%, 35% 65%)',
                    duration: 0.5,
                    ease: 'power2.in'
                });
                if (dot) {
                    gsap.killTweensOf(dot);
                    gsap.to(dot, {
                        scale: 1,
                        backgroundColor: '#ffffff',
                        opacity: 0.5,
                        duration: 0.3,
                        ease: 'power2.in',
                        onComplete: function () {
                            dot.style.animation = '';
                        }
                    });
                }
                // ripristina tutti gli altri label + dot
                document.querySelectorAll('.geo-label').forEach(function (other) {
                    if (other === label) {
                        return null;
                    }
                    const otherDot = other.querySelector('.geo-label__dot');
                    if (otherDot) {
                        gsap.killTweensOf(other);
                        gsap.to(other, {
                            color: '#ffffff',
                            opacity: 1,
                            duration: 0.3,
                            ease: 'power2.out',
                            onComplete: function () {
                                gsap.set(otherDot, {backgroundColor: '#ffffff'});
                                otherDot.style.animation = '';
                            }
                        });
                    } else {
                        gsap.killTweensOf(other);
                        gsap.to(other, {
                            color: '#ffffff',
                            opacity: 1,
                            duration: 0.3,
                            ease: 'power2.out'
                        });
                    }
                });
            });
        });
    });
}

export {initGeoCostellazione, initGeoUniverso};
